import React, {useCallback, useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {addIdeaComment, fetchIdeaComments, selectIdeasStatus,} from "store/currentBoardSlice";

import Button from "layout/atoms/Button";
import Form from "layout/atoms/Form";
import InputText from "layout/atoms/InputText";
import Loader from "layout/atoms/Loader";

import {Wrapper} from "./styles";

const Comments = ({ boardId, ideaId, commentCount, onCommentAdded }) => {
  const dispatch = useDispatch();
  const {
    addIdeaComment: addCommentStatus,
    fetchIdeaComments: fetchCommentsStatus,
  } = useSelector(selectIdeasStatus);
  const { t } = useTranslation("translation", {
    keyPrefix: "boardsDetails.forms.addComment",
  });
  const { t: tGeneral } = useTranslation("translation");
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues: { text: "" } });
  const [comments, setComments] = useState([]);
  const [counter, setCounter] = useState(commentCount ?? 0);
  const [expandedComments, setExpandedComments] = useState({});

  const toggleComment = (id) =>
    setExpandedComments((expanded) => ({ ...expanded, [id]: !expanded[id] }));

  useEffect(() => {
    if (commentCount != null) setCounter(comments.length);
  }, [commentCount, comments.length]);

  const loadComments = useCallback(() => {
    return dispatch(fetchIdeaComments({ ideaId, boardId }))
      .unwrap()
      .then((res) => {
        setComments(res.comments);
      });
  }, [dispatch, boardId, ideaId]);

  useEffect(() => {
    loadComments();
  }, [loadComments]);

  const addComent = (data) => {
    return dispatch(addIdeaComment({ data, ideaId, boardId }))
      .unwrap()
      .then(() => {
        reset();
        loadComments();
        setCounter(counter + 1);
        onCommentAdded && onCommentAdded();
      })
      .catch(() => {
        // Show Toast
      });
  };

  return (
    <Wrapper>
      <h4>
        {t("header")} ({counter})
      </h4>
      {fetchCommentsStatus === "loading" && comments.length === 0 && (
        <Loader size={30} />
      )}
      {comments.map((comment) => (
        <blockquote key={comment.commentDto.id}>
          <h5>
            {comment.author.displayName}{" "}
            <span>
              {comment.commentDto.createdAt.slice(8, 10)}/
              {comment.commentDto.createdAt.slice(5, 7)}/
              {comment.commentDto.createdAt.slice(0, 4)}
            </span>
          </h5>
          <p>
            {comment.commentDto.hasMore && !expandedComments[comment.commentDto.id]
              ? `${comment.commentDto.shortMessage}…`
              : comment.commentDto.message}
          </p>
          {comment.commentDto.hasMore && (
            <button
              type="button"
              className="show-more"
              onClick={() => toggleComment(comment.commentDto.id)}
            >
              {expandedComments[comment.commentDto.id]
                ? t("showLess")
                : t("showMore")}
            </button>
          )}
        </blockquote>
      ))}
      <Form onSubmit={handleSubmit(addComent)}>
        <InputText
          type="textarea"
          name="text"
          placeholder={t("fields.message.placeholder")}
          register={register}
          errors={errors.text}
          validation={{
            required: true,
            minLength: 6,
            maxLength: { value: 10000, message: tGeneral("formErrors.tooLong") },
          }}
        />
        <Button
          type="submit"
          size="lg"
          color="primary"
          loading={addCommentStatus === "loading"}
        >
          {t("buttons.save")}
        </Button>
      </Form>
    </Wrapper>
  );
};

export default Comments;
